// ============================================================
// THE COMPASS NEEDLE'S BEARING ON SCREEN (plan design-gaps, Z6; the session
// page's compass): which way north lies on the display, in degrees clockwise
// from straight up. North is -z (engine/stealth/contacts: +z runs south).
// Read off the projection itself at the point the camera holds, never off the
// yaw's sign, so the needle cannot point the wrong way round.
//
// Pure. Zero React dependency.
// ============================================================

import type { Camera } from '../battlefield/projection';
import { projectGround } from '../battlefield/projection';
import { wrap360 } from '../battlefield/facing';

/** North on screen, degrees clockwise from up: 0 when north is up, 90 when it is to the right. */
export function northOnScreen(camera: Camera): number {
  const { x, z } = camera.target;
  const here = projectGround({ x, z }, camera);
  const north = projectGround({ x, z: z - 1 }, camera);
  return wrap360((Math.atan2(north.x - here.x, here.y - north.y) * 180) / Math.PI);
}
